import React from 'react';
import { ArrowBack } from 'styled-icons/material';
import Tooltip from '@material-ui/core/Tooltip';

export default function (props) {
  const { onClick, title, volumenVacancy, totalCandidates, _AddColumnFirebase } = props;

  return (
    <div className="grid-2">
      <div className="leftBox">
        <label className="titleMain">
          <ArrowBack size="25" onClick={() => onClick()} cursor="pointer" /> {title}{' '}
          <Tooltip
            title={volumenVacancy ? `${totalCandidates} personas pre-filtradas.` : 'lapieza - vacante normal'}
            placement="top"
            arrow>
            <strong style={{ fontSize: '12px' }}>{volumenVacancy ? ' | Alto volumen' : ''}</strong>
          </Tooltip>{' '}
        </label>
      </div>

      <div className="grid-end grid-1">
        <div style={{ alignSelf: 'center' }}>
          <button className="button__submit__" onClick={() => _AddColumnFirebase()}>
            Nueva Columna
          </button>
        </div>
      </div>
    </div>
  );
}
